<template>
  <div class="feedback-form">
    <slot name="txtBefore"></slot>
    <FeedbackQuestion v-for="(question, index) in questions" :key="question.id" :question="question" :answer.sync="answers[question.id]" :question-index= "++index" >
      <template v-for="slot in possibleChildSlotsFor('Question')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </FeedbackQuestion>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import FeedbackQuestion from './Question.vue'
import slotProxy from '../../../../mixins/slotProxy'
export const stepName = 'feedbackForm'
export default {
  name: 'FeedbackForm',
  data () {
    return {
      answers: {},
      loadingNext: false
    }
  },
  watch: {
    answers: function (answers) {
      this.$emit('update:answers', answers)
    }
  },
  mixins: [
    slotProxy()
  ],
  components: { FeedbackQuestion },
  props: {
    questions: {
      type: Array
    }
  }
}
</script>
